import React from "react";
import "./styles/ImportDropDowns.css";
import { useTranslation } from "react-i18next";
import ImportDropDown from "./ImportDropDown";
import {
  IMPORT_MAKE_MODEL_PROPS,
  IMPORT_MAKE_PROPS,
  IMPORT_MODEL_PROPS,
  IMPORT_SUB_MODEL_PROPS,
  IMPORT_ENGINE_PROPS,
  IMPORT_VIN_CODE_PROPS,
  IMPORT_UNIT_PROPS,
  IMPORT_COMMENTS_PROPS,
  IMPORT_MODEL_YEAR_PROPS,
} from "../../utils/GlobalConstants";

const ImportDropDowns = ({
  tableHeader,
  handleChange,
  showErrorMsg,
  surveyDetails,
}) => {
  const dropdowns = [
    {
      label: "Make/Model",
      props: { ...IMPORT_MAKE_MODEL_PROPS, value: surveyDetails.makeModel },
    },
    {
      label: "Make",
      props: { ...IMPORT_MAKE_PROPS, value: surveyDetails.make },
    },
    {
      label: "Model",
      props: { ...IMPORT_MODEL_PROPS, value: surveyDetails.model },
    },
    {
      label: "SubModel",
      props: { ...IMPORT_SUB_MODEL_PROPS, value: surveyDetails.subModel },
    },
    {
      label: "Engine",
      props: { ...IMPORT_ENGINE_PROPS, value: surveyDetails.engine },
    },
    {
      label: "ModelYear",
      props: { ...IMPORT_MODEL_YEAR_PROPS, value: surveyDetails.year },
    },
    {
      label: "VinCode",
      props: { ...IMPORT_VIN_CODE_PROPS, value: surveyDetails.vin },
    },
    {
      label: "Unit",
      props: { ...IMPORT_UNIT_PROPS, value: surveyDetails.unitNo },
    },
    {
      label: "Comments",
      props: { ...IMPORT_COMMENTS_PROPS, value: surveyDetails.comments },
    },
  ];
  const { t } = useTranslation();

  return (
    <>
      <div>
        <div className="fleet-survey-name-container">
          <span>{t("header.Fleet_Survey")}</span>
        </div>
        <div></div>
        {showErrorMsg && (
          <p className="item-center color-red">
            {t("tab2.contents.messages.fieldErrMsg")}
          </p>
        )}
        <div className="import-dropdown-container">
          {dropdowns.map((item, key) => (
            <ImportDropDown
              key={key}
              label={item.label}
              tableHeader={tableHeader}
              selectProps={{ ...item.props, onChange: handleChange }}
            />
          ))}
        </div>
      </div>
    </>
  );
};
export default ImportDropDowns;
